import RecipientWellWithFindControlViewState from 'owa-recipient-common/lib/store/schema/RecipientWellWithFindControlViewState';
import addReadWriteRecipients from '../actions/addReadWriteRecipients';

export default function useTypedAddress(
    recipientWell: RecipientWellWithFindControlViewState
): void {
    addReadWriteRecipients(recipientWell, [
        { isValid: true, newPersona: null, newEmailAddress: recipientWell.queryString },
    ]);
}
